import Vue from 'vue'

const directive = {
  bind: function (el: any, binding: any, vnode: any) {
    vnode.componentInstance.$on('input', (e: any) => {
      const { targetVariable, lastPart } = getVariables(vnode, binding);
      vnode.componentInstance.$set(targetVariable, lastPart, e);
    });
  },
}

function getVariables(vnode : any, binding: any) {
    const variable = binding.value.variable ? binding.value.variable : binding.value;
    const parent = binding.value.parent ? binding.value.parent : vnode.context;
    let targetVariable = parent.variables;
    const dividedExpression = variable.split('.');
    const lastPart = dividedExpression.pop()
    dividedExpression.forEach((part: string) => {
      if (targetVariable[part] == undefined) {
        vnode.componentInstance.$set(targetVariable, part, {});
      }
      targetVariable = targetVariable[part];
    })
    return { targetVariable, lastPart };
}

Vue.directive('dynamic-model', directive);
